<template>
	<div class="wrapper">
		<div class="advwrap"></div>
		<div class="div_input">
			<p style="color: #0d0d0d; text-align: center; font-size: 18px; font-weight: 500; padding-bottom: 15px">
				{{parkName}}</p>
			<div class="div_name">输入车牌号查询停车费</div>
			<div class="div_licensePlate">
				<ul>
					<li v-bind:class="{'li_show':input_index==0}">
						<input
								type="text"
								maxlength="1"
								v-model="inputtext.substring(0,1)"
								@blur="animateWidth(0,'blur')"
								@focus="animateWidth(0,'focus')"
						/>
					</li>
					<li v-bind:class="{'li_show':input_index==1}">
						<input
								style="color: #0d0d0d"
								type="text"
								maxlength="1"
								v-model="inputtext.substring(1,2)"
								@blur="animateWidth(1,'blur')"
								@focus="animateWidth(1,'focus')"
						/>
					</li>
					<li v-bind:class="{'li_show':input_index==2}">
						<input
								style="color: #0d0d0d"
								type="text"
								maxlength="1"
								v-model="inputtext.substring(2,3)"
								@blur="animateWidth(2,'blur')"
								@focus="animateWidth(2,'focus')"
						/>
					</li>
					<li v-bind:class="{'li_show':input_index==3}">
						<input
								style="color: #0d0d0d"
								type="text"
								maxlength="1"
								v-model="inputtext.substring(3,4)"
								@blur="animateWidth(3,'blur')"
								@focus="animateWidth(3,'focus')"
						/>
					</li>
					<li v-bind:class="{'li_show':input_index==4}">
						<input
								style="color: #0d0d0d"
								type="text"
								maxlength="1"
								v-model="inputtext.substring(4,5)"
								@blur="animateWidth(4,'blur')"
								@focus="animateWidth(4,'focus')"
						/>
					</li>
					<li v-bind:class="{'li_show':input_index==5}">
						<input
								style="color: #0d0d0d"
								type="text"
								maxlength="1"
								v-model="inputtext.substring(5,6)"
								@blur="animateWidth(5,'blur')"
								@focus="animateWidth(5,'focus')"
						/>
					</li>
					<li v-bind:class="{'li_show':input_index==6}">
						<input
								style="color: #0d0d0d"
								type="text"
								maxlength="1"
								v-model="inputtext.substring(6,7)"
								@blur="animateWidth(6,'blur')"
								@focus="animateWidth(6,'focus')"
						/>
					</li>
					<li v-if="ifNewEnergy" v-bind:class="{'li_show':input_index==7}">
						<input
								style="color: #0d0d0d"
								type="text"
								maxlength="1"
								v-model="inputtext.substring(7,8)"
								@blur="animateWidth(7,'blur')"
								@focus="animateWidth(7,'focus')"
						/>
					</li>
				</ul>
			</div>
			<div class="div_check" v-on:click="checkIsNewEnergy">
				<div class="div_left" v-bind:class="{'check':ifNewEnergy}">
					<img src="../../common/img/check.png" alt/>
				</div>
				<div class="div_right">是否为新能源车牌</div>
			</div>
			<div class="div_button" v-on:click="queryRecord">查询缴费</div>
		</div>
		<div class="div_explain">
			<div class="div_name">临停支付说明</div>
			<div class="div_text">
				<p>1.若因特殊原因无法查询车辆信息，请至人工收费处进行处理；</p>
				<p>2.查询缴费前请仔细核对停车场、车牌号；</p>
				<p>3.若无法加载页面，请检查网络是否畅通或耐心等待、重新加载页面。</p>
			</div>
		</div>
		<div id="keycontent" v-if="keycontentShow">
			<div id="keyboard">
				<div class="keyTitle" v-on:click="button_close">关闭</div>
				<div class="keyContent">
					<ul>
						<li
								v-for="(nub,index) in list"
								v-bind:class="li_show(index,listType)"
								v-on:click="keycontent_val(nub)"
								:key="index"
						>
							<p>{{nub}}</p>
						</li>
					</ul>
					<div class="button_tab button" v-on:click="listType=!listType">
						<div>切换</div>
					</div>
					<div class="button_delete button" v-on:click="button_delete">
						<div>删除</div>
					</div>
				</div>
			</div>
			<div id="keyMask" v-on:click="button_close"></div>
		</div>
	</div>
</template>

<script>
	import { getScanConfig } from "../../api/coupon/personalBind";
    import { getBasicConfig, getParkingPaymentInfo } from "api/coupon/area";
    import {mapMutations, mapGetters} from "vuex";

    export default {
        data() {
            return {
                parkName: undefined,
                ifNewEnergy: false,
                list: [],
                parkCoupon:0,
                inputtext: "苏",
                listType: true,
                keycontentShow: false,
                licensePlate_provinces: [
                    "京",
                    "沪",
                    "粤",
                    "津",
                    "冀",
                    "晋",
                    "蒙",
                    "辽",
                    "吉",
                    "黑",
                    "苏",
                    "浙",
                    "皖",
                    "闽",
                    "赣",
                    "鲁",
                    "豫",
                    "鄂",
                    "湘",
                    "桂",
                    "琼",
                    "渝",
                    "川",
                    "贵",
                    "云",
                    "藏",
                    "陕",
                    "甘",
                    "青",
                    "宁",
                    "新",
                    "使",
                    "领",
                    "警",
                    "学",
                    "港",
                    "澳"
                ],
                licensePlate_letter: [
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "0",
                    "Q",
                    "W",
                    "E",
                    "R",
                    "T",
                    "Y",
                    "U",
                    "I",
                    "O",
                    "P",
                    "A",
                    "S",
                    "D",
                    "F",
                    "G",
                    "H",
                    "J",
                    "K",
                    "L",
                    "Z",
                    "X",
                    "C",
                    "V",
                    "B",
                    "N",
                    "M"
                ],
                input_index: 1,
                // 停车场Id
                parkinglotId: "",
                // 车牌号码
                plateNumber: "",
                // 金额
                amount: 0.0,
                // 停车场名字
                plateName: "",
                // 进出记录Id
                parkRecId: "",
                areaId: "",
                keyTopOrderNo: undefined,
                scrollOptions: {
                    click: true,
                    bounce: false
                },
            };
        },
        mounted() {
            if (this.$route.query.parkinglotId) {
                this.parkinglotId = this.$encryptUtil.decrypt(this.$route.query.parkinglotId);
                this.$api.parkinglot.getParkinglotInfo(this.parkinglotId).then(res => {
                    this.parkName = res.data.data.parkName;
                    this.setParkingInfo(res.data.data);
                    this.setOpenAD(res.data.data.isOpenAdvertising);
                    if (res.data.data.isOpenAdvertising == 1) {
                   
                        
                        let data = {
                            address: res.data.data.address,
                            parkName: res.data.data.parkName
                        };
                        this.$api.parkinglot.getParkId(data).then(res => {
                            if (res.data.code === 200) {
                                this.setAbParkId(res.data.data.parkId);
                                this.$getAdInfo(res.data.data.parkId)
                            } else {
                                if (this.abParkId) {
                                    this.$getAdInfo(this.abParkId)
                                }
                            }
                        })
					}

                })
            }
            if (this.$route.query.areaId) {
                this.areaId = this.$encryptUtil.decrypt(
                    this.$route.query.areaId
                );
            }

            this.listType = true;
            this.setList();
            this.getBasicConfig();
            if (this.lastPlateno.length == 8) {
                this.ifNewEnergy = true;
                this.inputtext = this.lastPlateno;
                this.input_index = 7;
                this.keycontentShow = true;
                this.listType = false;
            } else if (this.lastPlateno.length == 7) {
                this.inputtext = this.lastPlateno;
                this.input_index = 7;
                this.keycontentShow = true;
                this.listType = false;
            }
        },
        watch: {
            listType: function (val, oldval) {
                this.setList();
            }
        },
        methods: {
            getLocationFromGD() {
                let url = location.href.split("#")[0];
                getScanConfig({url}).then(res => {
                    let appId = res.data.appId;
                    let nonceStr = res.data.nonceStr;
                    let timestamp = res.data.timestamp;
                    let signature = res.data.signature;
                    this.wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId, // 必填，公众号的唯一标识
                        nonceStr, // 必填，生成签名的随机串
                        timestamp, // 必填，生成签名的时间戳
                        signature, // 必填，签名，见附录1
                        jsApiList: ['getLocation'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    });
                    this.wx.ready(() => {
                        this.wx.getLocation({
                            debug: false,
                            type: "gcj02",
                            success: res => {
                                alert(res.longitude + ',' + res.latitude);
                                this.$jsonp('https://restapi.amap.com/v3/geocode/regeo?output=jsonp', {
                                    location: res.longitude + ',' + res.latitude,//39.984154,116.307490 res.latitude + ',' + res.longitude
                                    key: '3fa3b5ccf04973bb6834cf3edc0a7377',
                                }).then(res => {
                                    if (res.status == 1){
                                        alert(res.regeocode.addressComponent.adcode);
                                        alert(res.regeocode.addressComponent.district);
                                        alert(res.regeocode.formatted_address);
                                        this.cityCode = res.regeocode.addressComponent.adcode;
                                        this.visitCommunity.code = this.cityCode;
                                        this.setVisitorCom(this.visitCommunity)
                                    } else {
                                        alert(res.info)
                                    }
                                })
                            },
                            cancel: res => {
                                this.$weui.confirm('警告', {
                                    title: '用户拒绝授权获取地理位置',
                                    buttons: [{
                                        label: '取消',
                                        type: 'default',
                                        onClick: () => {
                                            console.log('no')
                                        }
                                    }, {
                                        label: '重新授权',
                                        type: 'primary',
                                        onClick: () => {
                                            this.getLocationFromGD()
                                        }
                                    }]
                                });
                            }
                        });
                        this.wx.error(function(res){
                            alert("接口调取失败")
                        });
                    })
                })
            },
            getBasicConfig() {
                getBasicConfig(this.areaId).then(res => {
                    this.setInterfaceManner(res.data.interfaceManner);
                    this.setIsCardPay(res.data.isCardPay);
                })
            },
            getParkingPaymentInfo() {
                let data = {
                    parkinglotId: this.parkinglotId,
                    ts: new Date().getTime(),
                    plateNo: this.inputtext
                };
                this.$api.area.getParkingPaymentInfo(data).then(res => {
                    this.parkFeeToast(res)
                })
            },
            li_show: function (index, type) {
                // console.log(index + "===" + type);
                if (type) {
                    if (index == 30) {
                        return "li_right";
                    }
                } else {
                    if (index == 20) {
                        return "li_left";
                    }
                    if (index == 29) {
                        return "li_right";
                    }
                }
            },
            setList: function () {
                if (this.listType) {
                    this.list = this.licensePlate_provinces;
                } else {
                    this.list = this.licensePlate_letter;
                }
            },
            animateWidth: function (index, type) {
                console.log(index + "===" + type);
                document.activeElement.blur();
                if (index == 0) {
                    if (type == "blur") {
                        this.input_index = 0;
                        console.log("移除省");
                    } else {
                        this.input_index = index;
                        console.log("移入省");
                        this.keycontentShow = true;
                        this.listType = true;
                    }
                } else if (index == 1) {
                    if (type == "blur") {
                        console.log("移除字母");
                        this.input_index = 0;
                    } else {
                        this.input_index = index;
                        console.log("移入字母");
                        this.keycontentShow = true;
                        this.listType = false;
                    }
                } else {
                    if (type == "blur") {
                        console.log("移除");
                        this.input_index = 0;
                    } else {
                        this.input_index = index;
                        console.log("移入");
                        this.keycontentShow = true;
                        this.listType = false;
                    }
                }
            },
            button_delete: function () {
                var t = [];
                if (this.ifNewEnergy) {
                    t = ["", "", "", "", "", "", "", ""];
                } else {
                    t = ["", "", "", "", "", "", ""];
                }
                var i = this.input_index;
                if (i - 1 != t.length) {
                    if (!this.ifNewEnergy) {
                        i--;
                    }
                }
                for (var j = 0; j < this.inputtext.split("").length; j++) {
                    t[j] = this.inputtext.split("")[j];
                }

                console.log(i);
                for (var j = 0; j < t.length; j++) {
                    if (j == i) {
                        t[j] = "";
                    }
                }
                // $.each(this.inputtext.split(""), function(k, v) {
                //   t[k] = v;
                // });
                // $.each(t, function(k, v) {
                //   if (k == i) {
                //     t[k] = "";
                //   }
                // });
                this.inputtext = t.join("");
                console.log(t);
                this.input_index > 0 ? this.input_index-- : this.input_index;
                this.animateWidth(this.input_index, "focus");
            },
            button_close: function () {
                this.keycontentShow = false;
            },
            keycontent_val: function (val) {
                var i = this.input_index;
                var t = [];
                if (this.ifNewEnergy) {
                    t = ["", "", "", "", "", "", "", ""];
                } else {
                    t = ["", "", "", "", "", "", ""];
                }

                for (var j = 0; j < this.inputtext.split("").length; j++) {
                    t[j] = this.inputtext.split("")[j];
                }

                console.log(i);
                for (var j = 0; j < t.length; j++) {
                    if (j == i) {
                        t[j] = val;
                    }
                }
                // $.each(this.inputtext.split(""), function(k, v) {
                //   t[k] = v;
                // });
                // $.each(t, function(k, v) {
                //   if (k == i) {
                //     t[k] = val;
                //   }
                // });
                console.log(t);
                this.inputtext = t.join("");
                console.log(this.input_index);
                this.input_index < 7 ? this.input_index++ : this.input_index;
                this.animateWidth(this.input_index, "focus");
            },
            checkIsNewEnergy() {
                this.ifNewEnergy = !this.ifNewEnergy;
            },
            queryRecord() {
                if (this.inputtext.length == 7 || this.inputtext.length == 8) {
                    console.log(this.inputtext);
                    var text = this.inputtext;
                    if (this.interfaceManner == 2) {//科拓对接
                        this.getParkingPaymentInfo()
                    } else {
                        this.$api.parkinglot.getRecordByPlateNo(text, this.parkinglotId, this.areaId).then(res => {
                            console.log(res,'提前缴费')
                                if(res.data.code==200){
                                    this.parkCoupon =res.data.data.parkCoupon
                                this.parkFeeToast(res)
                                }else{
                                    this.$createDialog({
                        type: "confirm",
                        icon: "cubeic-alert",
                        title: this.plateName,
                        content: res.data.msg,
                        confirmBtn: {
                            text: "确定",
                            active: true,
                            disabled: false,
                            href: "javascript:;"
                        }
                    }).show();
                                }
                               
                            });
                    }

                } else {
                    this.$createDialog({
                        type: "confirm",
                        icon: "cubeic-alert",
                        title: this.plateName,
                        content: "车牌号长度错误",
                        confirmBtn: {
                            text: "确定",
                            active: true,
                            disabled: false,
                            href: "javascript:;"
                        }
                    }).show();
                }
            },
            parkFeeToast(res) {
                if (res.data.code == 200 && res.data.data) {
                    this.plateNumber = res.data.data.plateno;
                    this.amount = res.data.data.unpaidMoney;
                    this.parkRecId = res.data.data.id;
                    this.setParkrec(res.data.data);
                   console.log(res.data.data,'res.data.data')
                    this.setKeyTopInImgUrl(res.data.data.inImgUrl);
                    this.areaId = res.data.data.areaId;
                    console.log(res.data.data.areaId);
                    this.keyTopOrderNo = res.data.data.keyTopOrderNo;
                    this.setAreaId(res.data.data.areaId);
                    this.setParkingId(this.parkinglotId);
                    if (res.data.data.actualMoney) {
                        this.$createDialog({
                            type: "confirm",
                            icon: "cubeic-alert",
                            title: this.plateName,
                            content: "请至出口扫码缴费",
                            confirmBtn: {
                                text: "确定",
                                active: true,
                                disabled: false,
                                href: "javascript:;"
                            },
                            onConfirm: () => {
                                this.hint = "请至出口扫码缴费";
                                this.isShowHint = false;
                            },
                            onCancel: () => {
                                this.hint = "请至出口扫码缴费";
                                this.isShowHint = false;
                            }
                        }).show();
                    } else if (this.amount == 0) {
                        this.$createDialog({
                            type: "confirm",
                            icon: "cubeic-alert",
                            title: this.plateName,
                            content:
                                "&nbsp;&nbsp;&nbsp;&nbsp;车牌为『" +
                                this.plateNumber +
                                "』的车主您好，您需要缴费" +
                                this.amount +
                                "元，无需支付",
                            confirmBtn: {
                                text: "确定",
                                active: true,
                                disabled: false,
                                href: "javascript:;"
                            },
                            onConfirm: () => {
                                this.hint = "无需支付";
                                this.isShowHint = false;
                            },
                            onCancel: () => {
                                this.hint = "无需支付";
                                this.isShowHint = false;
                            }
                        }).show();
                    } else {
                        if(res.data.data.parkinglotId == 157){
                            this.showNtConfirm(res.data);
                        }else{
                            this.showConfirm(res.data);
                        }
                    }
                
                    
                } else {
                    // 提示当前无车辆出场
                    this.$createDialog({
                        type: "confirm",
                        icon: "cubeic-alert",
                        title: this.plateName,
                        content: "未查询到该车辆进场记录，请前往岗亭联系管理员",
                        confirmBtn: {
                            text: "确定",
                            active: true,
                            disabled: false,
                            href: "javascript:;"
                        },
                        onConfirm: () => {
                            this.hint = "未查询到该车辆进场记录，请前往岗亭联系管理员";
                            this.isShowHint = false;
                        },
                        onCancel: () => {
                            this.hint = "未查询到该车辆进场记录，请前往岗亭联系管理员";
                            this.isShowHint = false;
                        }
                    }).show();
                }
            },
            showConfirm(plateInfo) {
                this.$createDialog({
                    type: "confirm",
                    icon: "cubeic-location",
                    title: this.plateName,
                    content:
                        "&nbsp;&nbsp;&nbsp;&nbsp;车牌为『" +
                        this.plateNumber +
                        "』的车主您好，您需要缴费" +
                        this.amount +
                        "元",
                    confirmBtn: {
                        text: "去缴费",
                        active: true,
                        disabled: false,
                        href: "javascript:;"
                    },
                    cancelBtn: {
                        text: "取消",
                        active: false,
                        disabled: false,
                        href: "javascript:;"
                    },
                    onConfirm: () => {
                        if (this.parkRecId) {
                            if (!this.amount || !this.parkinglotId || !this.areaId) {
                                this.$createDialog({
                                    type: "confirm",
                                    icon: "cubeic-alert",
                                    title: "提示",
                                    content: "请重新扫码",
                                    confirmBtn: {
                                        text: "确定",
                                        active: true,
                                        disabled: true,
                                        href: "javascript:;"
                                    },
                                }).show();
                                return
                            }
                            this.$api.order.order({
                                    totalPrice: parseFloat(this.amount).toFixed(2),
                                    parkRec: this.parkRecId,
                                    parkinglotId: this.parkinglotId,
                                    goodsType: 3,
                                    closed: 0,
                                    paymentPlatform: this.checkBrowser.id,
                                    areaId: this.areaId,
                                    paymentPlatformsn: this.keyTopOrderNo
                                })
                                .then(res => {
                                    console.log(res.data);
                                    if (res.data.code == 200) {
                                        this.setOrderInfo(res.data.data);
                                        this.setLastPlateno(this.inputtext);
                                        this.setOrderSnList({});
                                        // if (plateInfo.couponid) {
                                        //     this.$router.push({name: "Order", params: {isEntry: true}});
                                        // }else {
                                            console.log(res.data.data,'vuex存储')
                                            console.log(this.inputtext,'this.inputtext')
                                          
                                        this.$router.push({name: "InsideOrder", params: {isEntry: true,}});
                                        // }

                                    } else {
                                        this.showAlert(res.data.msg);
                                    }
                                });
                        } else {
                            // 当前记录无ID
                            this.$api.parkinglot.getRecordByPlateNo(this.plateNumber, this.parkinglotId, this.areaId).then(res => {
                                if (res.data.code === 200) {
                                    if (res.data.data.id) {
                                        this.setParkRecId(res.data.data.id);
                                        this.$api.order
                                            .order({
                                                totalPrice: parseFloat(this.amount).toFixed(2),
                                                parkRec: res.data.data.id,
                                                parkinglotId: this.parkinglotId,
                                                goodsType: 3,
                                                closed: 0,
                                                paymentPlatform: this.checkBrowser.id,
                                                areaId: this.areaId,
                                                paymentPlatformsn: this.keyTopOrderNo
                                            })
                                            .then(res => {
                                                console.log(res.data);
                                                if (res.data.code == 200) {
                                                    this.setOrderInfo(res.data.data);
                                                    this.setLastPlateno(this.inputtext);
                                                    this.setOrderSnList({});
                                                    // if (plateInfo.couponid) {
                                                    //     this.$router.push({name: "Order", params: {isEntry: true}});
                                                    // }else {
                                                     
                                                    this.$router.push({name: "InsideOrder", params: {isEntry: true}});
                                                    // }

                                                } else {
                                                    this.showAlert(res.data.msg);
                                                }
                                            });
                                    } else {
                                        let data = {
                                            totalPrice: parseFloat(this.amount).toFixed(2),
                                            parkinglotId: this.parkinglotId,
                                            goodsType: 3,
                                            closed: 0,
                                            paymentPlatform: this.checkBrowser.id,
                                            areaId: this.areaId,
                                            paymentPlatformsn: this.keyTopOrderNo,
                                            plateno: this.plateNumber
                                        };
                                        this.$api.parkinglot.noRecOrder(data).then(res => {
                                            if (res.data.code == 200) {
                                                this.setOrderInfo(res.data.data);
                                                this.setLastPlateno(this.inputtext);
                                                this.setOrderSnList({});
                                              
                                                this.$router.push({name: "InsideOrder", params: {isEntry: true}});
                                            } else {
                                                this.showAlert(res.data.msg);
                                            }
                                        })
                                    }
                                } else {
                                    let data = {
                                        totalPrice: parseFloat(this.amount).toFixed(2),
                                        parkinglotId: this.parkinglotId,
                                        goodsType: 3,
                                        closed: 0,
                                        paymentPlatform: this.checkBrowser.id,
                                        areaId: this.areaId,
                                        paymentPlatformsn: this.keyTopOrderNo,
                                        plateno: this.plateNumber
                                    };
                                    this.$api.parkinglot.noRecOrder(data).then(res => {
                                        if (res.data.code == 200) {
                                            this.setOrderInfo(res.data.data);
                                            this.setLastPlateno(this.inputtext);
                                            this.setOrderSnList({});
                                            
                                            this.$router.push({name: "InsideOrder", params: {isEntry: true}});
                                        } else {
                                            this.showAlert(res.data.msg);
                                        }
                                    })
                                }

                            });
                        }
                    },
                    onCancel: () => {
                        this.$createToast({
                            type: "warn",
                            time: 3000,
                            txt: "您取消了缴费"
                        }).show();
                        this.hint = "您取消了缴费，请重新扫码";
                        this.isShowHint = false;
                    }
                }).show();
            },
            showNtConfirm(plateInfo) {
                this.$createDialog({
                    type: "confirm",
                    icon: "cubeic-location",
                    title: this.plateName,
                    content:
                        "&nbsp;&nbsp;&nbsp;&nbsp;车牌为『" +
                        this.plateNumber +
                        "』的车主您好，您需要缴费" +
                        this.amount +
                        "元<br/>"+ "<p style=\"font-size: 12px;\">"+plateInfo.data.remark,
                    confirmBtn: {
                        text: "去缴费",
                        active: true,
                        disabled: false,
                        href: "javascript:;"
                    },
                    cancelBtn: {
                        text: "取消",
                        active: false,
                        disabled: false,
                        href: "javascript:;"
                    },
                    onConfirm: () => {
                        if (this.parkRecId) {
                            if (!this.amount || !this.parkinglotId || !this.areaId) {
                                this.$createDialog({
                                    type: "confirm",
                                    icon: "cubeic-alert",
                                    title: "提示",
                                    content: "请重新扫码",
                                    confirmBtn: {
                                        text: "确定",
                                        active: true,
                                        disabled: true,
                                        href: "javascript:;"
                                    },
                                }).show();
                                return
                            }
                           
                            this.$api.order.order({
                                    totalPrice: parseFloat(this.amount).toFixed(2),
                                    parkRec: this.parkRecId,
                                    parkinglotId: this.parkinglotId,
                                    goodsType: 3,
                                    closed: 0,
                                    paymentPlatform: this.checkBrowser.id,
                                    areaId: this.areaId,
                                    paymentPlatformsn: this.keyTopOrderNo
                                })
                                .then(res => {
                                    console.log(res.data);
                                    if (res.data.code == 200) {
                                        this.setOrderInfo(res.data.data);
                                        this.setLastPlateno(this.inputtext);
                                        this.setOrderSnList({});
                                        // if (plateInfo.couponid) {
                                        //     this.$router.push({name: "Order", params: {isEntry: true}});
                                        // }else {
                                          
                                        this.$router.push({name: "InsideOrder", params: {isEntry: true}});
                                        // }

                                    } else {
                                        this.showAlert(res.data.msg);
                                    }
                                });
                        } else {
                            // 当前记录无ID
                            this.$api.parkinglot.getRecordByPlateNo(this.plateNumber, this.parkinglotId, this.areaId).then(res => {
                                if (res.data.code === 200) {
                                    if (res.data.data.id) {
                                        this.setParkRecId(res.data.data.id);
                                        this.$api.order
                                            .order({
                                                totalPrice: parseFloat(this.amount).toFixed(2),
                                                parkRec: res.data.data.id,
                                                parkinglotId: this.parkinglotId,
                                                goodsType: 3,
                                                closed: 0,
                                                paymentPlatform: this.checkBrowser.id,
                                                areaId: this.areaId,
                                                paymentPlatformsn: this.keyTopOrderNo
                                            })
                                            .then(res => {
                                                console.log(res.data);
                                                if (res.data.code == 200) {
                                                    this.setOrderInfo(res.data.data);
                                                    this.setLastPlateno(this.inputtext);
                                                    this.setOrderSnList({});
                                                    // if (plateInfo.couponid) {
                                                    //     this.$router.push({name: "Order", params: {isEntry: true}});
                                                    // }else {
                                                      
                                                    this.$router.push({name: "InsideOrder", params: {isEntry: true}});
                                                    // }

                                                } else {
                                                    this.showAlert(res.data.msg);
                                                }
                                            });
                                    } else {
                                        let data = {
                                            totalPrice: parseFloat(this.amount).toFixed(2),
                                            parkinglotId: this.parkinglotId,
                                            goodsType: 3,
                                            closed: 0,
                                            paymentPlatform: this.checkBrowser.id,
                                            areaId: this.areaId,
                                            paymentPlatformsn: this.keyTopOrderNo,
                                            plateno: this.plateNumber
                                        };
                                        this.$api.parkinglot.noRecOrder(data).then(res => {
                                            if (res.data.code == 200) {
                                                this.setOrderInfo(res.data.data);
                                                this.setLastPlateno(this.inputtext);
                                                this.setOrderSnList({});
                                                
                                                this.$router.push({name: "InsideOrder", params: {isEntry: true}});
                                            } else {
                                                this.showAlert(res.data.msg);
                                            }
                                        })
                                    }
                                } else {
                                    let data = {
                                        totalPrice: parseFloat(this.amount).toFixed(2),
                                        parkinglotId: this.parkinglotId,
                                        goodsType: 3,
                                        closed: 0,
                                        paymentPlatform: this.checkBrowser.id,
                                        areaId: this.areaId,
                                        paymentPlatformsn: this.keyTopOrderNo,
                                        plateno: this.plateNumber
                                    };
                                    this.$api.parkinglot.noRecOrder(data).then(res => {
                                        if (res.data.code == 200) {
                                            this.setOrderInfo(res.data.data);
                                            this.setLastPlateno(this.inputtext);
                                            this.setOrderSnList({});
                                            
                                            this.$router.push({name: "InsideOrder", params: {isEntry: true}});
                                        } else {
                                            this.showAlert(res.data.msg);
                                        }
                                    })
                                }

                            });
                        }
                    },
                    onCancel: () => {
                        this.$createToast({
                            type: "warn",
                            time: 3000,
                            txt: "您取消了缴费"
                        }).show();
                        this.hint = "您取消了缴费，请重新扫码";
                        this.isShowHint = false;
                    }
                }).show();
            },
            showAlert(value) {
                this.$createDialog({
                    type: "confirm",
                    icon: "cubeic-alert",
                    title: this.plateName,
                    content: value,
                    confirmBtn: {
                        text: "确定",
                        active: true,
                        disabled: false,
                        href: "javascript:;"
                    }
                }).show();
            },
            ...mapMutations({
                setOrderInfo: "SET_ORDER_INFO",
                setParkrec: "SET_PARKREC",
                setOrderSnList: "SET_ORDERSNLIST",
                setParkingId: "SET_PARKINGLOTID",
                setParkingInfo: "SET_PARKING_INFO",
                setLastPlateno: "SET_LAST_PLATENO",
                setAreaId: 'SET_AREA_ID',
                setIsnotification: 'SET_ISNOTIFICATION',
                setInterfaceManner: "SET_INTERFACEMANNER",
                setKeyTopInImgUrl: "SET_KEYTOPINIMGURL",
                setIsCardPay: "SET_ISCARDPAY",
                setAbParkId: "SET_ABPARKID",
                setOpenAD: "SET_OPENAD"
            })
        },
        computed: {
            ...mapGetters(["lastPlateno", "interfaceManner", "abParkId"])
        }
    };
</script>

<style lang="stylus" scoped>
	@import '~common/stylus/variable';
	@import '~common/stylus/mixin';

	.wrapper {
		position: relative;
		width: 100%;
		height: 100%;
		background: #f5f5f5;
		.cube-scroll {
			position: relative;
			text-align: left;
			white-space: normal;
			max-height: 100%
			overflow hidden
			/*background: #ffffff;*/
			margin-bottom 50px
		}
		.div_input {
			background: #ffffff;
			margin-top: 12px;
			padding: 20px;

			.div_name {
				color #0d0d0d
				font-size: 16px;
				font-weight: bold;
				line-height: 20px;
				margin-bottom: 25px;
			}

			.div_licensePlate {
				margin-bottom: 15px;
				border: 1px solid #5495f6;
				height: 44px;
				border-radius: 6px;
				overflow: hidden;

				ul {
					width: 100%;
					height: 100%;
					display: flex;
					padding: 0px;
					list-style: none;
					margin: 0px;

					li {
						height: 100%;
						border-left: 1px solid #5495f6;
						flex: 1;
						position: relative;
						box-sizing: border-box;

						input {
							position: absolute;
							left: 0px;
							top: 0px;
							width: 100%;
							height: 44px;
							border: 0px;
							background: initial;
							font-size: 16px;
							text-align: center;
							font-weight: bold;
							line-height: 44px;
						}
					}

					.li_show {
						border-bottom: 2px solid #ffffff;
						animation: li_show 1.5s infinite linear;
					}

					@keyframes li_show {
						0% {
							border-bottom: 2px solid #ffffff;
						}

						50% {
							border-bottom: 0px;
						}

						100% {
							border-bottom: 2px solid #ffffff;
						}
					}

					li:nth-child(1) {
						border-left: 0px;
						background: #5495f6;
						color: #ffffff;

						input {
							color: #ffffff;
						}
					}
				}
			}

			.div_check {
				margin-bottom: 15px;
				display: flex;
				flex-direction: row;
				align-items: center;

				.div_left {
					height: 20px;
					width: 20px;
					border: 1px solid #dddddd;
					margin-right: 8px;

					img {
						width: 100%;
						height: 100%;
						display: none;
					}
				}

				.check {
					border: 0px;

					img {
						display: block;
					}
				}

				.div_right {
					color #0d0d0d
					font-size: 16px;
				}
			}

			.div_button {
				color: #ffffff;
				width: 100%;
				height: 45px;
				background: #5495f6;
				box-shadow: 0px 5px 5px 0px rgba(84, 149, 246, 0.25);
				border-radius: 5px;
				font-size: 16px;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				letter-spacing: 3px;
				margin-top: 16px;
			}
		}

		#keycontent {
			position: fixed;
			width: 100%;
			height: 50%;
			bottom: 0px;
			left: 0px;
			z-index: 999
			#keyboard {
				position: absolute;
				bottom: 0px;
				width: 100%;
				background-color: #d0d3d9;
				font-size: 14px;
				z-index: 9999;

				.keyTitle {
					height: 40px;
					line-height: 40px;
					font-size: 1em;
					text-align: right;
					background-color: #ffffff;
					border-top: 1px solid #f2f2f2;
					color: #5495f6;
					padding: 0px 12px;
				}

				.keyContent {
					padding: 4px 2px 4px 2px;
					position: relative;

					ul {
						width: 100%;
						overflow: hidden;
						padding: 0px;
						list-style: none;
						margin: 0px;

						li {
							float: left;
							padding: 2px 2px;
							width: 10%;
							box-sizing: border-box;

							p {
								color #0d0d0d
								height: 45px;
								line-height: 45px;
								background-color: #ffffff;
								text-align: center;
								border-radius: 4px;
								font-size: 1em;
								box-shadow: 0px 2px 2px 0px rgb(152, 155, 160);
							}
						}

						.li_left {
							margin-left: 5%;
						}

						.li_right {
							margin-left: 15%;
						}
					}

					.button {
						padding: 2px 2px;
						width: 13%;

						div {
							height: 45px;
							line-height: 45px;
							background-color: #a8b0bc;
							text-align: center;
							border-radius: 4px;
							font-size: 1em;
							box-shadow: 0px 2px 2px 0px rgb(152, 155, 160);
						}
					}

					.button_tab {
						position: absolute;
						left: 2px;
						bottom: 4px;
					}

					.button_delete {
						position: absolute;
						right: 2px;
						bottom: 4px;
					}
				}
			}

			#keyMask {
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0px;
				left: 0px;
				z-index: 1;
			}
		}

		.div_explain {
			background-color: #fff;
			margin-top: 8px;
			padding: 20px;

			.div_name {
				font-size: 16px;
				margin-bottom: 15px;
				line-height: 20px;
				font-weight: bold;
			}

			.div_text p {
				margin: 0px;
				font-size: 14px;
				line-height: 28px;
			}
		}
	}
</style>
